export function filterNull<T>(value: T | null): value is T {
  return value !== null
}
